/**
 * Mobile dock (sections/mobile-dock.liquid): keeps the cart bubble live
 * and opens the cart drawer from the dock's cart item.
 *
 * The bubble updates on the `cart:updated` CustomEvent that
 * assets/cart.js dispatches (with {detail: {cart}}) from CartAPI.refresh()
 * and reconcileLine() - the same signal the rest of the theme trusts. The
 * dock does NOT reuse the [data-cart-count] hook, because cart.js writes
 * to querySelector('[data-cart-count]') - one element only - and a second
 * claimant would leave one of the two bubbles stale.
 *
 * Cart tap mirrors cart.js's header enhancement: open the drawer if it
 * exists, otherwise let the link navigate to /cart (which is also the
 * no-JS path).
 */
(function () {
  function updateBubble(cart) {
    var bubble = document.querySelector('[data-dock-cart-count]');
    if (!bubble || !cart) return;
    bubble.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
  }

  document.addEventListener('cart:updated', function (event) {
    updateBubble(event.detail && event.detail.cart);
  });

  // Delegated rather than bound to the anchor: the theme editor re-renders
  // the section (replacing the anchor) on every setting change, and a
  // document-level listener survives that.
  document.addEventListener('click', function (event) {
    var anchor = event.target.closest('[data-dock-cart]');
    if (!anchor) return;
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(anchor);
  });
})();
